export default __webpack_public_path__ + "static/media/logo-error.8f6e9e69.svg";